export default __webpack_public_path__ + "static/article-the-reality-of-work-and-travel-marrakech-66fb902db19544af14ba6713faf7464d.jpg";